<script lang="ts">
	import type { SplittedAddress } from '$lib/components/pois/types';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import SkeletonButton from '$lib/components/atoms/skeleton/SkeletonButton.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		address?: SplittedAddress | null;
		isLoading?: boolean;
		hasError?: boolean;
		notFound?: boolean;
		onAddClick?: () => void;
		onRetryClick?: () => void;
		onCancelPosition?: (cancelAction: boolean) => void;
	}

	const {
		address = null,
		isLoading = false,
		hasError = false,
		notFound = false,
		onAddClick,
		onRetryClick,
		onCancelPosition,
	}: Props = $props();

</script>

<div class="flex flex-col relative rd-2 shadow-subtle p-2 min-w-0 bg-neutral-weakest w-full">
	<div data-testid="floating-summary--title" class="truncate text-md text-bold text-coloredneutral">
		{#if isLoading}
			<SkeletonText minWords={2} maxWords={3} minWordLength={6} maxWordLength={15} />
		{:else if hasError || notFound}
			{m.address__summary__error__title()}
		{:else if address !== null}
			{address.firstLine}
		{/if}
	</div>
	<div data-testid="floating-summary--detail" class="truncate text-sm text-coloredneutral mt-1">
		{#if isLoading}
			<SkeletonText minWords={2} maxWords={3} minWordLength={6} maxWordLength={15} />
		{:else if hasError || notFound}
			{m.address__summary__error__detail()}
		{:else if address !== null}
			{address.secondLine}
		{/if}
	</div>
	<div class="mt-2">
		{#if isLoading}
			<div class="flex gap-2">
				<SkeletonButton text={m.poi_actions__itinerary()} size="sm" hasIcon />
				<SkeletonButton text={m.poi_actions__cancel()} size="sm" />
			</div>
		{:else if hasError}
			<Button
				variant="outline"
				size="sm"
				icon="autorenew"
				text={m.action__retry()}
				onclick={onRetryClick}
			/>
		{:else if address && !notFound}
			<div class="flex gap-2">
				<ButtonAddToItinerary
					size="sm"
					onclick={onAddClick}
				/>
				<Button
					color="white"
					size="sm"
					text={m.poi_actions__cancel()}
					variant="filled"
					onclick={() => onCancelPosition?.(true)}
				/>
			</div>
		{:else}
			<div class="btn-sm"></div>
		{/if}
	</div>
</div>
